import UserAccount from "../../models/user-account";
import {
  axiosInstance as Repository,
} from "../repository";

const RESOURCE = "/account";

// APIのレスポンスからUserAccountのインスタンスを生成
function getInstance(item) {
  const obj = new UserAccount();
  obj.userAccontId = item.user_id;
  obj.userName = item.name;

  return obj;
}

export default {
  async get() {
    const response = await Repository.get(`${RESOURCE}`);
    return getInstance(response.data.item);
  },
};
